module.exports = __webpack_public_path__ + "static/broadcast-3-may.707c531c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/broadcast-3-may.jpg
// module id = 579
// module chunks = 35783957827783